import { useNavigate, useParams } from 'react-router-dom';
import LaunchingRegisterForm from './LaunchingRegisterForm/LaunchingRegisterForm';
import { RegisterFormVariants } from './LaunchingRegisterForm/LaunchingRegisterForm.types';
import { Helmet } from 'react-helmet';
import { FORM_TITLE_QUERY_KEY, FormTitleQuery } from './LaunchingRegister.query';
import { useEffect } from 'react';
import Footer from '../../../commons/Footer/Footer';
import Menu from '../../../commons/Menu/Menu';
import { useQuery } from 'react-query';

export default () => {
  const { variant } = useParams();
  const navigate = useNavigate();

  const isVariantCorrect =
    variant && !Object.values(RegisterFormVariants).find((formVariant) => formVariant === variant);

  useEffect(() => {
    if (isVariantCorrect) {
      console.log('******');
      navigate('/');
    }
  });

  // useEffect(() => {
  //   refetch()
  // }, [variant])

  if (isVariantCorrect) {
    return null;
  }

  // @ts-ignore // isInitialLoading isn't recongnized by Typescript but exists
  const { data, isInitialLoading } = useQuery(
    [FORM_TITLE_QUERY_KEY, variant as unknown as RegisterFormVariants],
    () => FormTitleQuery(variant as unknown as RegisterFormVariants)
  );

  if (isInitialLoading) return <p>isInitialLoading</p>;

  return (
    <>
      <Helmet>
        <title>{data?.display_title}</title>
      </Helmet>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Menu />
        <div style={{ flex: 1 }}>
          <h1 style={{ padding: 'var(--spacing-m)' }}>{data?.display_title}</h1>

          <LaunchingRegisterForm variant={variant as unknown as RegisterFormVariants} />
        </div>
        {/* <div className="footer_fixed_to_bottom"> */}
        <Footer />
        {/* </div> */}
      </div>
    </>
  );
};
